import styled from 'styled-components'
import { colors } from '../../../../../styles/constants'

export const Title = styled.h1`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 19px;
  text-align: center;
  color: ${colors.gray.dark};
  margin-bottom: 4px;
`

export const Subtitle = styled.h2`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  margin-bottom: 16px;
  color: ${colors.gray.dark};
`
export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  align-items: center;
`
